<template>
  <v-layout>
    <v-dialog v-model="show" max-width="800px" lazy>
      <v-card>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 md8 order-xs2 order-md1>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="editedItem.firstName"
                        @keyup.enter="save"
                        label="First Name"
                        ref="focusName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md1>
                      <v-text-field
                        v-model="editedItem.middle"
                        @keyup.enter="save"
                        label="M"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        v-model="editedItem.lastName"
                        @keyup.enter="save"
                        label="Last Name"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-model="editedItem.address1"
                    @keyup.enter="save"
                    label="Address"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-layout wrap>
                    <v-flex xs10 md5>
                      <v-text-field
                        v-model="editedItem.city"
                        @keyup.enter="save"
                        label="City"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 md2>
                      <v-text-field
                        v-model="editedItem.state"
                        @keyup.enter="save"
                        label="ST"
                        mask="AA"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md5>
                      <v-text-field
                        v-model="editedItem.zip"
                        @keyup.enter="save"
                        label="Zipcode"
                        mask="#####"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
              <v-flex xs12 md4 order-xs1 order-md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <v-flex xs12 text-xs-center>
                  <v-layout wrap>
                    <v-flex xs12>
                      <croppa
                        v-model="croppa"
                        :initial-image="initialImage"
                        :placeholder-font-size="14"
                        :prevent-white-space="true"
                        :disable-drag-and-drop="false"
                        :width="180"
                        :height="180"
                        :zoom-speed="7"
                      >
                      </croppa>
                    </v-flex>
                    <v-flex xs12>
                      <v-btn
                        flat
                        icon
                        color="primary"
                        small
                        @click="croppa.rotate(-1)"
                      >
                        <v-icon>rotate_left</v-icon>
                      </v-btn>
                      <v-btn
                        flat
                        icon
                        color="primary"
                        small
                        @click="croppa.rotate()"
                      >
                        <v-icon>rotate_right</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs12>
                      <strong>( {{ titleName }})</strong>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 md8>
                <v-text-field
                  v-model="editedItem.email"
                  @keyup.enter="save"
                  label="Email Address"
                  prepend-icon="email"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4>
                <v-text-field
                  v-model="editedItem.password"
                  id="password"
                  @keyup.enter="save"
                  label="Password"
                  prepend-icon="lock"
                  :append-icon="showpassword ? 'visibility_off' : 'visibility'"
                  :type="showpassword ? 'text' : 'password'"
                  @click:append="() => (showpassword = !showpassword)"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-select
                  :items="mobileTypes"
                  v-model="editedItem.MobileTypeId"
                  menu-props="auto"
                  label="Mobile Type"
                  hide-details
                  prepend-icon="cellphone-cog"
                  @keyup.enter="save"
                ></v-select>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.cellPhone"
                  @keyup.enter="save"
                  label="Mobile"
                  mask="(###) ###-####"
                  return-masked-value
                  prepend-icon="stay_current_portrait"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.homePhone"
                  @:keyup.enter="save"
                  label="Home"
                  mask="(###) ###-####"
                  return-masked-value
                  prepend-icon="phone"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  v-model="editedItem.workPhone"
                  @keyup.enter="save"
                  label="Work"
                  mask="(###) ###-####"
                  return-masked-value
                  prepend-icon="business"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md3>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu1"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="formattedDate"
                    label="Birth Date"
                    prepend-icon="cake"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    @change="editedItem.birthDate = parseDate(formattedDate)"
                  ></v-text-field>
                  <v-date-picker
                    v-model="editedItem.birthDate"
                    no-title
                    @input="menu1 = false"
                    @change="formattedDate = formatDate(editedItem.birthDate)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            v-if="saving"
            @click.stop="show=false"
          >Cancel</v-btn>
          <v-btn
            color="blue darken-1"
            transition="fade-transition"
            v-if="!saving"
            flat
            @click.stop="show=false"
          >Close</v-btn>
          <v-btn
            color="blue darken-1"
            dark
            transition="fade-transition"
            v-if="saving"
            @click.native="save"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'
import Utilities from '@/services/Utilities'
import 'vue-croppa/dist/vue-croppa.css'
import moment from 'moment'

export default {
  props: ['visible', 'item'],

  data () {
    return {
      menu1: false,
      formattedDate: '',
      saving: false,
      showpassword: false,
      snackbar: {
        show: false,
        color: '',
        message: ''
      },
      activeTab: '',
      statuses: [
        { text: 'Inactive', value: 'inactive' },
        { text: 'Active', value: 'active' }
      ],
      handBooks: [
        { text: 'No', value: false },
        { text: 'Yes', value: true }
      ],
      croppa: {},
      initialImage: null,
      editedItem: this.item,
      titleName: '',
      mobileTypes: []
    }
  },

  filters: {
    formatDate (value) {
      if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
      }
    }
  },

  created () {
    this.titleName = this.$store.state.user.Title.name

    this.getMobileTypes()
  },

  computed: {
    show: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      }
    }
  },

  watch: {
    visible (val) {
      if (val) {
        console.log('test')
        this.loadItem()
      }
    },
    editedItem: {
      handler: function (val, oldVal) {
        console.log('test')
        this.saving = true
      },
      deep: true
    }
  },

  methods: {
    loadItem () {
      this.editedItem = this.item

      let image = new Image()
      image.setAttribute('crossorigin', 'anonymous')
      image.src = this.editedItem.picture

      this.initialImage = image
      this.formattedDate = moment(this.editedItem.birthDate).format('MM/DD/YYYY')
    },

    formatDate (date) {
      return Utilities.displayDate(date)
    },

    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    async getMobileTypes () {
      try {
        const response = await Api().get('mobiletypes')
        this.mobileTypes = response.data
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    async save () {
      this.editedItem.dataUrl = this.croppa.generateDataUrl('image/jpeg', 0.8)

      try {
        const response = await Api().put('update_profile/' + this.editedItem.id, this.editedItem)
        this.$store.dispatch('setUser', this.editedItem)

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    }
  }
}
</script>

<style>
.centered-input input {
  text-align: center
}

.croppa-container {
  background-color: white;
  border: 3px solid black
}

.scroll-here {
  overflow: auto;
  height: 340px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/forms/UserProfile.vue